var map = {
	"./1.webp": 3050,
	"./10.webp": 3206,
	"./11.webp": 2961,
	"./12.webp": 1364,
	"./13.webp": 5543,
	"./14.webp": 6266,
	"./15.webp": 7445,
	"./16.webp": 4392,
	"./2.webp": 5419,
	"./3.webp": 7048,
	"./4.webp": 9953,
	"./5.webp": 3574,
	"./6.webp": 4247,
	"./7.webp": 3236,
	"./8.webp": 8813,
	"./9.webp": 4098,
	"./darband.webp": 9797,
	"./gallery/1.webp": 1619,
	"./gallery/11.webp": 2698,
	"./gallery/12.webp": 5691,
	"./gallery/2.webp": 4194,
	"./gallery/4.webp": 1644,
	"./gallery/5.webp": 3183,
	"./gallery/6.webp": 6030,
	"./gallery/9.webp": 2187,
	"./hero.webp": 4583,
	"./menu/m1.webp": 8079,
	"./menu/m2.webp": 3086,
	"./menu/m3.webp": 873,
	"./menu/m4.webp": 5744,
	"./menu/m5.webp": 6147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7723;